import { render, staticRenderFns } from "./AffiliateTrainingCard.vue?vue&type=template&id=64f7b0b8&"
import script from "./AffiliateTrainingCard.vue?vue&type=script&lang=js&"
export * from "./AffiliateTrainingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports